/**
 * @desc 根据母仓列表获取子仓列表信息
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  params: API.fulfilment.warehouseFacadeImpl.getChildWarehouseListByRoot.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/warehouse/getChildWarehouseListByRoot`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
